export const networking = {
  'fullProfile': 'Full Profile',
  'QrBadge': 'QR Badge',
  'myNetwork': 'My Network',
  'seeAll': 'See all',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Check them out!',
  'activities': 'Activities',
  'topicsToDiscuss': 'Topics to discuss',
  'OneOnOneMeet': '1:1 Meet',
  'leaderboard': 'Leaderboard',
  'learnMoreNetworking': 'Learn more about Networking Hub',
  'scanQrCode': 'Scan QR code',
  'myBadge': 'My badge',
  'scannedBadge': 'Scanned badge',
  'viewProfile': 'View Profile',
  'message': 'Message',
  'userRatingDetails': 'User Rating Details',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Total score:',
  'scoreComposedOf': 'This score is composed of:',
  'confirmationText': "Are you sure? This can't be undone.",
  'discussionTopic': 'Discussion Topic',
  'notes': 'Notes',

  'welcomeMessage': "Welcome to the <strong>Networking Hub</strong>, where connections come to life! Here's how it works:",
  'connectingMadeSimpleTitle': 'Connecting Made Simple',
  'connectingMadeSimpleDescription': 'The Networking Hub offers structured activities and levels to help you connect effectively:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Explore profiles of newcomers, shortlist interesting ones, and send messages. You can even connect with them personally.',
  'shortlistDescription': '<strong>Shortlist:</strong> Once you show interest in someone, they’re added to your shortlist.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> When you reach out and receive a response, they move to these buckets.',
  'skipDescription': '<strong>Skip:</strong> Not interested? Simply skip the profile, and move on!',

  'enhancedNetworkingActivitiesTitle': 'Enhanced Networking Activities',
  'enhancedNetworkingActivitiesDescription': 'In addition to direct connections, the Hub includes:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Explore topics that interest you and connect with authors or participants. Join online discussions, or schedule group meetings to dive deeper into these topics.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Manage meeting requests, track planned meetings, and organize your schedule effortlessly.',

  'gamificationTitle': 'Gamification for Fun and Engagement',
  'gamificationDescription':
    'Boost your activity with a leaderboard that tracks your points and showcases the most active networkers. Here’s how you can earn points:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1,000 points:</strong> Complete your profile (including a photo).',
    points1000PushNotifications: '<strong>1,000 points:</strong> Enable push notifications.',
    points100SendMeetingRequest: '<strong>100 points:</strong> Send a 1:1 meeting request.',
    points400GetAcceptedRequest: '<strong>400 points:</strong> Get your 1:1 request accepted.',
    points400AcceptRequest: '<strong>400 points:</strong> Accept a 1:1 request.',
    points100DeclineRequest: '<strong>100 points:</strong> Decline a 1:1 request.',
    points400CreateDiscussion: '<strong>400 points:</strong> Create a discussion topic.',
    points50LikeDiscussion: '<strong>50 points:</strong> Like a discussion topic.',
    points200PostFirstComment: '<strong>200 points:</strong> Anytime you post your first comment on another topic.',
    points100LikeOnTopic: '<strong>100 points:</strong> Earn a like on your topic.',
    points200UniqueCommenter: '<strong>200 points:</strong> Gain a unique commenter on your topic.',
    points100LikeShortlistUser: '<strong>100 points:</strong> Like/shortlist a user (add them to your shortlist).',
    points50SkipUser: '<strong>50 points:</strong> Skip a user.',
    points200StartChat: '<strong>200 points:</strong> Start a chat (contacted).',
    points300GetChatResponse: '<strong>300 points:</strong> Get a response in a chat (connected).',
    points400RespondToChat: '<strong>400 points:</strong> Respond to a chat request (connected).',
    points500SpeedNetworking: '<strong>500 points:</strong> For each speed networking session.'
  },

  'finalMessage':
    'Make the most of the Networking Hub, discover new opportunities, and climb the leaderboard as you connect and engage with like-minded professionals!',

  'manageMeeting': 'Manage meeting',
  'addToCalendar': 'Add to calendar',
  'cancel': 'Cancel',
  'accept': 'Accept',
  'accept&addToCalendar': 'Accept & Add to calendar',
  'editDetails': 'Edit details',
  'reject': 'Reject',
  'delete': 'Delete',
  'exportContact': 'Export contact',
  'scheduleNewOneOnOne': 'Schedule new 1:1',
  'initiatedBy': 'Initiated by',
  'rejectedBy': 'Rejected by',
  'you': 'you',
  'meetPassed': 'Meet has passed',
  'meetInProgress': 'In progress',

  'myOneOnOne': 'My 1:1',

  'speed': {
    history: 'History',
    minutes: 'minutes',
    users_available: 'available',
    rules: 'Rules',
    activate: 'Activate',
    matching: 'Matching...',
    start: 'Start',
    find_a_user: 'Find a user with the same image',
    find_a_user_number: 'Find a user with the same number',
    waiting: 'Waiting...',
    speaking_now: 'Pitching now',
    networking_topics: 'Networking topics',
    session_ended: 'Session ended',
    find_next_partner: 'Find next partner',
    find_next_group: 'Find next group',
    partner_wasnt_ready: 'Partner wasn’t ready',
    partner_wasnt_ready_description: 'Seems like a partner wasn’t ready for discussion. Let’s find a new one!',
    start_matching: 'Start matching'
  },

  'findAndJoin': 'Find and join',
  'confirmStartTitle': 'Are you sure?',
  'confirmStartText': 'Are you sure that you found the correct group?',
  'confirmStartCancelButtonTitle': 'No',
  'confirmStartConfirmButtonTitle': 'Yes',

  'descriptionText': 'You need to first find your group, and only then press the "Start" button'
}
